// @flow

import React from 'react';
import _ from 'lodash';
import bemify from 'bemify-js';

import Button from 'app/common/components/Button';
import Icon from 'app/common/components/Icon';
import TextInput from 'app/common/components/TextInput';
import { Div } from 'app/common/components/AccessibleElement';

import type { Service as ServiceType } from 'app/service/types';

const bem = bemify('app-search');
const bemSearchResults = bemify('search-results');

type HomepageServiceSearchProps = {
  query: string,
  selectedService: ServiceType,
  matchedServices: Array<ServiceType>,
  defaultServices: Array<ServiceType>,
  updateAppSearchQuery: (query: string) => void,
  selectService: (service: ServiceType) => void,
};

const HomepageServiceSearch = (props: HomepageServiceSearchProps) => {
  const onChangeSearchQuery = (
    event: SyntheticInputEvent<HTMLInputElement>
  ) => {
    props.updateAppSearchQuery(event.target.value);
  };

  let btnText = 'Sign Up For Free';

  if (props.selectedService) {
    btnText =
      props.selectedService.name &&
      `Sign Up Now To Automate ${props.selectedService.name}`;
  }

  const signUpUrl = props.selectedService
    ? props.selectedService.key &&
      `/sign-up/?selected_apis=${props.selectedService.key}`
    : '/sign-up/';

  const matchedServices = _.isEmpty(props.query)
    ? props.defaultServices
    : props.matchedServices;

  // YOU CANNOT MAKE CHANGES TO THIS FILE WITHOUT ALSO UPDATING `templates/static/homepage/partials/app-search.html`
  return (
    <div className="apps-cta">
      <div className="app-search-container">
        <div className={bem()}>
          <Icon className={bem('__icon')} type="search" />
          <TextInput
            className={bem('__input')}
            onChange={onChangeSearchQuery}
            placeholder="Search for the apps you use..."
            type="search"
            value={props.query}
          />
        </div>
        <div className={bemSearchResults()}>
          <ul className={bemSearchResults('__list')}>
            {matchedServices.map(service => {
              const url = service.slug && '/generated/' + service.slug + '/128';
              const onClick = () => {
                props.selectService(service);
              };
              const className = bemSearchResults('__item', {
                '--selected':
                  props.selectedService &&
                  props.selectedService.key === service.key,
              });
              return (
                <li className={className} key={service.key}>
                  <Div
                    className={bemSearchResults('__selector')}
                    onClick={onClick}
                  >
                    <div
                      className={bemSearchResults('__app')}
                      style={{ backgroundImage: url && "url('" + url + "')" }}
                    />
                    {service.name}
                  </Div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
      <Button className={bem('__button')} href={signUpUrl} tag="a">
        {btnText}
      </Button>
    </div>
  );
};

export default HomepageServiceSearch;
